/* =========================================================================
   REVENDEURS — Remplacez cette liste par vos points de vente réels.
   Pour trouver les coordonnées (lat, lng) d'une adresse :
   ouvrez Google Maps, clic droit sur l'adresse → les coordonnées s'affichent.
   ========================================================================= */
/* Ordre d'affichage des pays. Les pays absents apparaissent à la fin. */
const ORDRE_PAYS = ["France", "Canada", "USA", "Rest of the World"];
function countryRank(c){
  const i = ORDRE_PAYS.indexOf(c);
  return i === -1 ? ORDRE_PAYS.length : i;
}
const REVENDEURS = [
{ name:"OPTIQUE WOLFF", addr:"44 Rue Maréchal de Lattre De Tassigny, 01190 Pont-de-Vaux", lat:46.4313, lng:4.9373, country:"France", state: "Auvergne-Rhône-Alpes", depar: "Ain", },
{ name:"LUNETTERIE SAUTAREL", addr:"40 Rue des Forgerons, 15000 Aurillac", lat:44.9291, lng:2.4458, country:"France", state: "Auvergne-Rhône-Alpes", depar: "Cantal", },
{ name:"OPTIQUE PELAT", addr:"45 Rue des Lacs, 15100 Saint-Flour", lat:45.0330, lng:3.0904, country:"France", state: "Auvergne-Rhône-Alpes", depar: "Cantal", },
{ name:"OPTIC 2000", addr:"5 Pl. de la Libération, 26110 Nyons", lat:44.3604, lng:5.1384, country:"France", state: "Auvergne-Rhône-Alpes", depar: "Drôme", },
{ name:"LINOSSIER OPTICIENS", addr:"37 Pl. du Breuil, 43000 Le Puy-en-Velay", lat:45.0422, lng:3.8853, country:"France", state: "Auvergne-Rhône-Alpes", depar: "Haute-Loire", },
{ name:"OPTIQUE PONCET", addr:"232 Rue de la Poste, 74120 Megève", lat:45.8575, lng:6.6167, country:"France", state: "Auvergne-Rhône-Alpes", depar: "Haute-Savoie", },
{ name:"IDENTITÉ VISUELLE OPTICIENS", addr:"39 Rue Marceau, 38000 Grenoble", lat:45.1815, lng:5.7230, country:"France", state: "Auvergne-Rhône-Alpes", depar: "Isère", },
{ name:"LA LUNETTERIE CLERMONTOISE", addr:"6 Rue des Gras, 63000 Clermont-Ferrand", lat:45.7790, lng:3.0850, country:"France", state: "Auvergne-Rhône-Alpes", depar: "Puy-de-Dôme", },
{ name:"LES OPTICIENS BERECLLO", addr:"20 Av. du Petit Port, 73100 Aix-les-Bains", lat:45.6936, lng:5.9090, country:"France", state: "Auvergne-Rhône-Alpes", depar: "Savoie", },
{ name:"CLIN D'OEIL", addr:"La Toison d'or, Centre commercial, 21000 Dijon", lat:47.3588, lng:5.0513, country:"France", state: "Bourgogne-Franche-Comté", depar: "Côte-d'Or", },
{ name:"LA LUNETTERIE BISONTINE", addr:"22 Pl. de la Révolution, 25000 Besançon", lat:47.2400, lng:6.0237, country:"France", state: "Bourgogne-Franche-Comté", depar: "Doubs", },
{ name:"OPTIQUE LAMY", addr:"25 Rue de Besançon, 39100 Dole", lat:47.0937, lng:5.4968, country:"France", state: "Bourgogne-Franche-Comté", depar: "Jura", },
{ name:"OPTIQUE WOLFF", addr:"20 Rue Lamartine, 71250 Cluny", lat:46.4333, lng:4.6591, country:"France", state: "Bourgogne-Franche-Comté", depar: "Saône-et-Loire", },
{ name:"OPTICIEN DINAN - KRYS", addr:"36 Rue du Marchix, 22100 Dinan", lat:48.4543, lng:-2.0462 , country:"France", state: "Bretagne", depar: "Côtes-d'Armor", },
{ name:"GRENIER MAISON D'OPTIQUE", addr:"94 Rue Jean Jaurès, 29200 Brest", lat:48.3946, lng:-4.4795, country:"France", state: "Bretagne", depar: "Finistère", },
{ name:"HISTOIRE DE REGARDS", addr:"3 Rue du Pont, 29800 Landerneau", lat:48.4509, lng:-4.2494, country:"France", state: "Bretagne", depar: "Finistère", },
{ name:"LE POINT DE VUE D'ALICE", addr:"Le Prieuré de Locmaria, 1 Rue du Chanoine Moreau, 29000 Quimper", lat:47.9888, lng:-4.1118, country:"France", state: "Bretagne", depar: "Finistère", },
{ name:"OPTICIEN PLOUDALMÉZEAU - ATOL", addr:"5 Rue de Brest, 29830 Ploudalmézeau", lat:48.5413, lng:-4.6578, country:"France", state: "Bretagne", depar: "Finistère", },
{ name:"OPTIQUE DENIS", addr:"13 Grand-Rue, 29600 Morlaix", lat:48.5772, lng:-3.8268, country:"France", state: "Bretagne", depar: "Finistère", },
{ name:"PLAISIR D’Y VOIR", addr:"route de Saint Pol, 29233 Cléder", lat:48.6662, lng:-4.0964, country:"France", state: "Bretagne", depar: "Finistère", },
{ name:"LUNETTERIE DU MAIL", addr:"52 Mail François Mitterrand, 35000 Rennes", lat:48.1097, lng:-1.6912, country:"France", state: "Bretagne", depar: "Ille-et-Vilaine", },
{ name:"OPTICIEN AUBEL", addr:"18 Rue Alphonse Milon, 35760 Saint-Grégoire", lat:48.1535, lng:-1.6840, country:"France", state: "Bretagne", depar: "Ille-et-Vilaine", },
{ name:"VIRGINIE ET JULIEN OPTICIENS", addr:"28 Rue ville Pépin, 35400 Saint-Malo", lat:48.6364, lng:-2.0151, country:"France", state: "Bretagne", depar: "Ille-et-Vilaine", },
{ name:"LA LUNETTERIE D'AURAY", addr:"45 Pl. de la République, 56400 Auray", lat:47.6662, lng:-2.9841, country:"France", state: "Bretagne", depar: "Morbihan", },
{ name:"RICHARD OPTICIEN", addr:"12 Pl. Alsace Lorraine, 56100 Lorient", lat:47.7502, lng:-3.3613, country:"France", state: "Bretagne", depar: "Morbihan", },
{ name:"OPTICIEN PURE BOURGES", addr:"25 Rue de Sarrebourg, 18000 Bourges", lat:47.0801, lng:2.4027, country:"France", state: "Centre-Val de Loire", depar: "Cher", },
{ name:"OPTICIEN PURE SAINT-DOULCHARD", addr:"404 Rte d'Orléans, 18230 Saint-Doulchard", lat:47.1089, lng:2.3783, country:"France", state: "Centre-Val de Loire", depar: "Cher", },
{ name:"CANAVESIO OTTICA", addr:"16 Rue du Soleil d'Or, 28000 Chartres", lat:47.3419, lng:0.7380, country:"France", state: "Centre-Val de Loire", depar: "Eure-et-Loir", },
{ name:"GEORGES OPTICIENS", addr:"1 Rue Jean-Marie Boivin, 37550 Saint-Avertin", lat:47.8875, lng:-2.8371, country:"France", state: "Centre-Val de Loire", depar: "Indre-et-Loire", },
{ name:"OPTICIEN BLOIS - OPTIC 2000", addr:"22 Rue du Commerce, 41000 Blois", lat:47.5864, lng:1.3340, country:"France", state: "Centre-Val de Loire", depar: "Loir-et-Cher", },
{ name:"BAR A LUNETTES", addr:"88 Rue nationale, 10200 Bar-sur-Aube", lat:48.2335, lng:4.7063, country:"France", state: "Grand Est", depar: "Aube", },
{ name:"AU DELÀ DU REGARD", addr:"2 place de l'église, 67700 Saverne", lat:48.7418, lng:7.3620, country:"France", state: "Grand Est", depar: "Bas-Rhin", },
{ name:"MAURICE FRÈRES", addr:"Rue des Hallebardes, 67000 Strasbourg", lat:48.5819, lng:7.7487, country:"France", state: "Grand Est", depar: "Bas-Rhin", },
{ name:"MAURICE FRÈRES", addr:"17 Rue Du Marché, 67210 Obernai", lat:48.4634, lng:7.4813, country:"France", state: "Grand Est", depar: "Bas-Rhin", },
{ name:"SCHNEIDER OPTIQUE", addr:"8 Marché aux Poissons, 67500 Haguenau", lat:48.8147, lng:7.7911, country:"France", state: "Grand Est", depar: "Bas-Rhin", },
{ name:"LA MAISON DE L'OPTICIEN", addr:"1 Pl. de la République, 68360 Soultz-Haut-Rhin", lat:47.8862, lng:7.2288, country:"France", state: "Grand Est", depar: "Haut-Rhin", },
{ name:"NAGELEISEN LA BOUTIQUE", addr:"4 Rue Du Raisin, 68100 Mulhouse", lat:47.7486, lng:7.3394, country:"France", state: "Grand Est", depar: "Haut-Rhin", },
{ name:"LUDOPTIQUE", addr:"54 Place De La République, 51000 Chalons en Champagne", lat:48.9567, lng:4.3621, country:"France", state: "Grand Est", depar: "Marne", },
{ name:"LUNETIERS ET CRÉATEURS", addr:"2 Rue De l'Arbalète, 51100 Reims", lat:49.2577, lng:4.0318, country:"France", state: "Grand Est", depar: "Marne", },
{ name:"GRAND OPTICIENS", addr:"33 Rue Saint Dizier, 54000 Nancy", lat:48.6894, lng:6.1827, country:"France", state: "Grand Est", depar: "Meurthe-et-Moselle", },
{ name:"HISTOIRE DES LUNETTES", addr:"12 Rue Raymond Poincaré, 54000 Nancy", lat:48.6923, lng:6.1811, country:"France", state: "Grand Est", depar: "Meurthe-et-Moselle", },
{ name:"OPTIC CHIC", addr:"6 Rue Carnot, 54300 Luneville", lat:48.5927, lng:6.4966, country:"France", state: "Grand Est", depar: "Meurthe-et-Moselle", },
{ name:"OPTIQUE PLEIN CENTRE", addr:"120 Avenue André Malraux, 54600 Villers Les Nancy", lat:48.6736, lng:6.1529, country:"France", state: "Grand Est", depar: "Meurthe-et-Moselle", },
{ name:"BO.OPTIQUE", addr:"13 rue Sainte-Croix, 57200 Sarreguemines", lat:49.1098, lng:7.0675, country:"France", state: "Grand Est", depar: "Moselle", },
{ name:"LE LUNETIER", addr:"2 Boucle Du Ferronnier, 57180 Terville", lat:49.3616, lng:6.1338, country:"France", state: "Grand Est", depar: "Moselle", },
{ name:"MV OPTIQUE", addr:"29 Rue De La Tête d'Or, 57000 Metz", lat:49.1194, lng:6.1756, country:"France", state: "Grand Est", depar: "Moselle", },
{ name:"LES LUNETTES DE NICOLAS", addr:"202 Rue De La Gare, 88100 Ste Marguerite", lat:48.2732, lng:6.9706, country:"France", state: "Grand Est", depar: "Vosges", },
{ name:"MIRETTES & ECOUTILLES", addr:"39 Rue Charles De Gaulle, 88400 Gerardmer", lat:48.0738, lng:6.8731, country:"France", state: "Grand Est", depar: "Vosges", },
{ name:"OPTIQUE TAVERNIER", addr:"16 Place Des Vosges, 88000 Epinal", lat:48.1731, lng:6.4509, country:"France", state: "Grand Est", depar: "Vosges", },
{ name:"LYNX OPTIQUE", addr:"Cc Milénis Lot 39, 97139 Guadeloupe", lat:16.2700, lng:-61.5320, country:"France", state: "Guadeloupe (Outre-mer)", depar: "Guadeloupe", },
{ name:"DERASSE OPTICIENS", addr:"35 Rue Croix Belle Porte, 02100 St Quentin", lat:49.8489, lng:3.2874, country:"France", state: "Hauts-de-France", depar: "Aisne", },
{ name:"CLAIR OPTIQUE", addr:"3 Rue Du General Leclerc, 59118 Wambrechies", lat:50.6854, lng:3.0479, country:"France", state: "Hauts-de-France", depar: "Nord", },
{ name:"LUNETTERIE MARTIN", addr:"409 Rue De Lille, 59223 Roncq", lat:50.7359, lng:3.1208, country:"France", state: "Hauts-de-France", depar: "Nord", },
{ name:"OPTIQUE DU FERRAIN", addr:"32 Rue De Tourcoing, 59960 Neuville en Ferrain", lat:50.7486, lng:3.1564, country:"France", state: "Hauts-de-France", depar: "Nord", },
{ name:"OPTIQUE POTISEK", addr:"21 Rue Clemenceau, 59140 Dunkerque", lat:51.0347, lng:2.3765, country:"France", state: "Hauts-de-France", depar: "Nord", },
{ name:"L'OPTICIEN DEGRUGILLIER", addr:"62 Rue René Lanoy, 62300 Lens", lat:50.4316, lng:2.8312, country:"France", state: "Hauts-de-France", depar: "Pas-de-Calais", },
{ name:"OPTIC 2000", addr:"12 Rue Wacquez Glasson, 62000 Arras", lat:50.2921, lng:2.7812, country:"France", state: "Hauts-de-France", depar: "Pas-de-Calais", },
{ name:"OPTIQUE ROBERT", addr:"12 Rue Des Lingers, 80100 Abbeville", lat:50.1056, lng:1.8346, country:"France", state: "Hauts-de-France", depar: "Somme", },
{ name:"LUNETTERIE DE L'IMPERATRICE", addr:"65 Avenue Paul Doumer, 92500 Rueil Malmaison", lat:48.8771, lng:2.1808, country:"France", state: "Île-de-France", depar: "Hauts-de-Seine", },
{ name:"OPTIQUE VAUCRESSON", addr:"3 Rue Allouard, 92420 Vaucresson", lat:48.8394, lng:2.1567, country:"France", state: "Île-de-France", depar: "Hauts-de-Seine", },
{ name:"MAISON BYLAART", addr:"22 Rue De Saint-pétersbourg, 75008 Paris", lat:48.8775, lng:2.3146, country:"France", state: "Île-de-France", depar: "Paris", },
{ name:"OPTIQUE WAGRAM", addr:"79 Avenue De Wagram, 75017 Paris", lat:48.8842, lng:2.2976, country:"France", state: "Île-de-France", depar: "Paris", },
{ name:"PASSION VISION", addr:"82 Boulevard Diderot, 75012 Paris", lat:48.8456, lng:2.3862, country:"France", state: "Île-de-France", depar: "Paris", },
{ name:"VUE AUTREMENT", addr:"3 Place De La Fontaine, 77400 Lagny Sur Marne", lat:48.8770, lng:2.7085, country:"France", state: "Île-de-France", depar: "Seine-et-Marne", },
{ name:"STEF'OPTIQUE", addr:"36 Rue Du Moutier, 94370 Sucy En Brie", lat:48.7712, lng:2.5349, country:"France", state: "Île-de-France", depar: "Val-de-Marne", },
{ name:"A VUE D'ŒIL", addr:"41 Rue De La Chapelle, 78630 Orgeval", lat:48.9204, lng:1.9756, country:"France", state: "Île-de-France", depar: "Yvelines", },
{ name:"CHEVREUSE OPTIQUE", addr:"32 Rue De La Division Leclerc, 78460 Chevreuse", lat:48.7079, lng:2.0314, country:"France", state: "Île-de-France", depar: "Yvelines", },
{ name:"LEMOINE OPTIC", addr:"71 Rue Juliette Dodu, 97400 Reunion", lat:-20.8823, lng:55.4504, country:"France", state: "La Réunion (Outre-mer)", depar: "La Réunion", },
{ name:"LUNETTERIE GAIO", addr:"15 Rue Saulnerie, 14500 Vire", lat:48.8386, lng:-0.8894, country:"France", state: "Normandie", depar: "Calvados", },
{ name:"OSE IRIS", addr:"9 Rue Pierre Aime Lair, 14000 Caen", lat:49.1829, lng:0.3707, country:"France", state: "Normandie", depar: "Calvados", },
{ name:"L'ATELIER DES BINOCLES", addr:"20 Rue De La République, 27500 Pont Audemer", lat:49.3559, lng:0.5136, country:"France", state: "Normandie", depar: "Eure", },
{ name:"L'OPTICIENNE DE LA VALLÉE", addr:"15A Rue de Louvier, 27490 Clef Vallee d'Eure", lat:49.1097, lng:1.3208, country:"France", state: "Normandie", depar: "Eure", },
{ name:"CORDON OPTIQUE", addr:"26 Rue Havin, 50000 St Lo", lat:49.1153, lng:-1.0911, country:"France", state: "Normandie", depar: "Manche", },
{ name:"MOREL OPTIQUE", addr:"34 Rue Albert Mahieu, 50100 Cherbourg", lat:49.6382, lng:-1.6164, country:"France", state: "Normandie", depar: "Manche", },
{ name:"IDEAL OPTIQUE", addr:"1 Rue Du Neubourg, 76500 Elbeuf", lat:49.2908, lng:1.0024, country:"France", state: "Normandie", depar: "Seine-Maritime", },
{ name:"LA VUE EN ROSE", addr:"2 Centre Commercial la Hêtraie, 76330 Notre Dame de Gravenchon", lat:49.4906, lng:0.5682, country:"France", state: "Normandie", depar: "Seine-Maritime", },
{ name:"LE LANCHON", addr:"7 Rue Guillaume Le Conquerant, 76000 Rouen", lat:49.4449, lng:1.1023, country:"France", state: "Normandie", depar: "Seine-Maritime", },
{ name:"LEFEVRE OPTIQUE", addr:"Le Mesnil Roux, 76360 Barentin", lat:49.5454, lng:0.9569, country:"France", state: "Normandie", depar: "Seine-Maritime", },
{ name:"OPTIC 2000 HULOT", addr:"Rue André-Paul Leroux, 76400 Fecamp", lat:49.7577, lng:0.3745, country:"France", state: "Normandie", depar: "Seine-Maritime", },
{ name:"SAINT ROCH OPTIQUE", addr:"54 Rue Georges Braque, 76600 Le Havre", lat:49.4969, lng:0.1077, country:"France", state: "Normandie", depar: "Seine-Maritime", },
{ name:"SUD OPTIQUE", addr:"99 Route de l'Ecuissière, 17550 Dolus D'Oleron", lat:45.9142, lng:-1.2628, country:"France", state: "Nouvelle-Aquitaine", depar: "Charente-Maritime", },
{ name:"VISINI ARTISAN LUNETIER", addr:"5 Rue De l'Hotel De Ville, 19100 Brive La Gaillarde", lat:45.1589, lng:1.5326, country:"France", state: "Nouvelle-Aquitaine", depar: "Corrèze", },
{ name:"HUGO OPTIQUE", addr:"27 Rue Victor Hugo, 79000 Niort", lat:46.3253, lng:-0.4613, country:"France", state: "Nouvelle-Aquitaine", depar: "Deux-Sèvres", },
{ name:"OPTIQUE DES CARMES", addr:"33 Pl. des Carmes, 87000 Limoges", lat:45.8299, lng:1.2500, country:"France", state: "Nouvelle-Aquitaine", depar: "Haute-Vienne", },
{ name:"PIERRE LISSAC", addr:"13 Place Fournier, 87000 Limoges", lat:45.8315, lng:1.2578, country:"France", state: "Nouvelle-Aquitaine", depar: "Haute-Vienne", },
{ name:"AU MONDE DES BINOCLES", addr:"58 Place Richard Feuillet, 40440 Ondres", lat:43.5656, lng:-1.4462, country:"France", state: "Nouvelle-Aquitaine", depar: "Landes", },
{ name:"MAISON DAIGNAS", addr:"14 Rue Alexander Taylor, 64000 Pau", lat:43.2976, lng:-0.3686, country:"France", state: "Nouvelle-Aquitaine", depar: "Pyrénées-Atlantiques", },
{ name:"OPTICIEN ALAIN AFFLELOU", addr:"Galerie Port Plaisance, 98807 Nouvelle-Caledonie", lat:-22.3110, lng:166.4420, country:"France", state: "Nouvelle-Calédonie (Outre-mer)", depar: "Nouvelle-Calédonie", },
{ name:"LE COMPTOIR DE L'OPTICIEN", addr:"17 Rue De l'Ancien Courrier, 11100 Narbonne", lat:43.1832, lng:3.0043, country:"France", state: "Occitanie", depar: "Aude", },
{ name:"OPTIC2000 RIVIER", addr:"5 Boulevard Théodore Lacombe, 30200 Bagnols Sur Ceze", lat:44.1624, lng:4.6198, country:"France", state: "Occitanie", depar: "Gard", },
{ name:"BRISSAUD OPTICIENS", addr:"Centre Commercial du Moulin à Vent, 31700 Mondonville", lat:43.6741, lng:1.2905, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"CARBONNE OPTIQUE", addr:"1 Place de la Republique, 31390 Carbonne", lat:43.2978, lng:1.2064, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"COTE VUE OPTIQUE", addr:"30, Avenue de Garossos, 31700 Beauzelle", lat:43.6712, lng:1.3669, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"COURDY OPTICIEN", addr:"39 Avenue De l'URSS, 31400 Toulouse", lat:43.6046, lng:1.4442, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"LOUIS MANVER LUNETTIER", addr:"29 Rue Des Filatiers, 31000 Toulouse", lat:43.6007, lng:1.4418, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"MAISON BINOCLE", addr:"Rue d'Austerlitz, 31490 Leguevin", lat:43.5964, lng:1.2346, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"MONTICELLI OPTIQUE", addr:"Centre Commercial de Saint-Caprais, 31240 L'Union", lat:43.6593, lng:1.4829, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"O PETIT MONOCLE", addr:"Avenue de Bequine, 31800 Estancarbon", lat:43.1298, lng:0.9207, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"ONO OPTIQUE", addr:"2 Rue Bernadet, 31830 Plaisance du Touch", lat:43.5652, lng:1.2937, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"RIQUIER OPTIQUE", addr:"62 Avenue Camille Pujol, 31500 Toulouse", lat:43.6124, lng:1.4738, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"VUE DE LEA", addr:"77 Route De Fronton, 31140 Aucamville", lat:43.6696, lng:1.4241, country:"France", state: "Occitanie", depar: "Haute-Garonne", },
{ name:"O MIL'YEUX", addr:"1 Rue en Rouan, 34000 Montpellier", lat:43.6083, lng:3.8771, country:"France", state: "Occitanie", depar: "Hérault", },
{ name:"BASSOMPIERRE OPTIQUE", addr:"35 Allées Paul Riquet, 34500 Beziers", lat:43.3442, lng:3.2187, country:"France", state: "Occitanie", depar: "Hérault", },
{ name:"ATOL OPTIQUE", addr:"14 Place Barthal, 46100 Figeac", lat:44.6083, lng:2.0312, country:"France", state: "Occitanie", depar: "Lot", },
{ name:"CHANARD OPTICIENS", addr:"2 Place Justin Bardou Job, 66000 Perpignan", lat:42.6986, lng:2.8959, country:"France", state: "Occitanie", depar: "Pyrénées-Orientales", },
{ name:"DUPARCHY OPTICIEN", addr:"10 Rue Alquier Bouffard, 81100 Castres", lat:43.6054, lng:2.2409, country:"France", state: "Occitanie", depar: "Tarn", },
{ name:"L'ATELIER DE CAMILLE", addr:"80 Av Mal De Lattre De Tassigny, 81000 Albi", lat:43.9282, lng:2.1480, country:"France", state: "Occitanie", depar: "Tarn", },
{ name:"L'ATELIER LOUBIN", addr:"1 Rue Des Frères Delga, 81600 Gaillac", lat:43.9019, lng:1.8968, country:"France", state: "Occitanie", depar: "Tarn", },
{ name:"MES PLUS BELLES LUNETTES", addr:"2 Rue Franklin, 44000 Nantes", lat:47.2184, lng:-1.5536, country:"France", state: "Pays de la Loire", depar: "Loire-Atlantique", },
{ name:"OPTICIEN DU BOIS JAUNI", addr:"37 rue Pierre de Coubertin, 44150 Ancenis", lat:47.3668, lng:-1.1759, country:"France", state: "Pays de la Loire", depar: "Loire-Atlantique", },
{ name:"OPTIQUE DES PINS", addr:"13 Rue Du Général De Gaulle, 44250 St Brevin Les Pins", lat:47.2488, lng:-2.1660, country:"France", state: "Pays de la Loire", depar: "Loire-Atlantique", },
{ name:"OPTIQUE POUSSIER", addr:"21 Rue De Couéré, 44110 Chateaubriant", lat:47.7164, lng:-1.3768, country:"France", state: "Pays de la Loire", depar: "Loire-Atlantique", },
{ name:"BEAUMARD OPTIQUE", addr:"28 Rue du Portail Louis, 49400 Saumur", lat:47.2606, lng:-0.0782, country:"France", state: "Pays de la Loire", depar: "Maine-et-Loire", },
{ name:"OPTIQUE MIREUX", addr:"23 Rue De La Paix, 53000 Laval", lat:48.0734, lng:-0.7688, country:"France", state: "Pays de la Loire", depar: "Mayenne", },
{ name:"OPTIC 2000", addr:"22 Place Thiers, 72130 Fresnay Sur Sarthe", lat:48.2846, lng:0.0257, country:"France", state: "Pays de la Loire", depar: "Sarthe", },
{ name:"ALAIN AFFLELOU", addr:"14 Place Napoléon, 85000 La Roche Sur Yon", lat:46.6705, lng:-1.4264, country:"France", state: "Pays de la Loire", depar: "Vendée", },
{ name:"CHERVET OPTICIEN", addr:"Rue des Bains Douches, 85500 Les Herbiers", lat:46.8726, lng:-1.0132, country:"France", state: "Pays de la Loire", depar: "Vendée", },
{ name:"L'OPTICIENNE DU POIRÉ", addr:"18 Place Du Marche, 85170 Le Poire Sur Vie", lat:46.7692, lng:-1.5084, country:"France", state: "Pays de la Loire", depar: "Vendée", },
{ name:"LA CHAUME OPTIQUE", addr:"13 Rue Joseph Benatier, 85100 Les Sables D'Olonne", lat:46.4969, lng:-1.7832, country:"France", state: "Pays de la Loire", depar: "Vendée", },
{ name:"LA LUNETTHEQUE", addr:"26 Rue Des Suisses, 13200 Arles", lat:43.6766, lng:4.6278, country:"France", state: "Provence-Alpes-Côte d'Azur", depar: "Bouches-du-Rhône", },
{ name:"LAPLANE OPTIQUE", addr:"607 Avenue Du Prado, 13008 Marseille", lat:43.2850, lng:5.3906, country:"France", state: "Provence-Alpes-Côte d'Azur", depar: "Bouches-du-Rhône", },
{ name:"ROMEO OPTICIENS", addr:"615 Boulevard Du Cerceron, 83700 St Raphael", lat:43.4233, lng:6.7681, country:"France", state: "Provence-Alpes-Côte d'Azur", depar: "Var", },
{ name:"OPTIQUE MERILHOU", addr:"11, rue de la République", lat:44.2409, lng:5.0745, country:"France", state: "Provence-Alpes-Côte d'Azur", depar: "Vaucluse", },
{ name:"VISU'ELLES", addr:"6 Rue Louis Pasteur, 84600 Valreas", lat:44.3837, lng:4.9902, country:"France", state: "Provence-Alpes-Côte d'Azur", depar: "Vaucluse", },
{ name:"HEALTHY EYE CARE", addr:"4525 North 24th Street, Phoenix AZ 85016", lat:33.5024, lng:-112.0301, country:"USA", state: "Arizona", depar: "", },
{ name:"20/20 OPTICAL", addr:"1127 4th Street, San Rafael CA 94901", lat:37.9731, lng:-122.5286, country:"USA", state: "California", depar: "", },
{ name:"COOPER OPTOMETRY", addr:"730 Wilshire Blvd, Santa Monica CA 90403", lat:34.0220, lng:-118.4946, country:"USA", state: "California", depar: "", },
{ name:"DOWNTOWN EYEWORKS", addr:"1301 Court St, Redding, CA 96001", lat:40.5851, lng:-122.3962, country:"USA", state: "California", depar: "", },
{ name:"EYES OF EAST SACRAMENTO", addr:"3315 Folsom Blvd, Sacramento CA 95816", lat:38.5673, lng:-121.4639, country:"USA", state: "California", depar: "", },
{ name:"GOGOSHA OPTIQUE", addr:"1555 W Sunset Blvd, Los Angeles CA 90026", lat:34.0765, lng:-118.2566, country:"USA", state: "California", depar: "", },
{ name:"INVISION OPTOMETRY", addr:"1907 Fillmore Street, San Francisco CA 94115", lat:37.7872, lng:-122.4336, country:"USA", state: "California", depar: "", },
{ name:"MODA OPTIQUE", addr:"415 S Lake Ave, Pasadena CA 91101", lat:34.1390, lng:-118.1324, country:"USA", state: "California", depar: "", },
{ name:"SECOND STREET OPTIQUE", addr:"4924 E 2nd Street, Long Beach CA 90803", lat:33.7612, lng:-118.1371, country:"USA", state: "California", depar: "", },
{ name:"URBAN OPTIKS", addr:"3788 Park Blvd, San Diego CA 92103", lat:32.7473, lng:-117.1464, country:"USA", state: "California", depar: "", },
{ name:"SPECS OF WESTPORT", addr:"115 Post Road East, Westport CT 6880", lat:41.1415, lng:-73.3599, country:"USA", state: "Connecticut", depar: "", },
{ name:"SPECTACLE GALLERY", addr:"1286 N Palm Avenue, Sarasota FL 34236", lat:27.3356, lng:-82.5439, country:"USA", state: "Florida", depar: "", },
{ name:"ROTHBLOOM EYECARE", addr:"1655 Spring Road SE, Smyrna GA 30080", lat:33.8824, lng:-84.5044, country:"USA", state: "Georgia", depar: "", },
{ name:"ARMSTRONG ROOT OPTICIANS", addr:"649 Sun Valley Road, Ketchum ID 83340", lat:43.6828, lng:-114.3613, country:"USA", state: "Idaho", depar: "", },
{ name:"EYELINES", addr:"112 West Monroe Street, Chicago IL 60603", lat:41.8808, lng:-87.6311, country:"USA", state: "Illinois", depar: "", },
{ name:"DOBBS OPTICAL", addr:"124 West South Street, Kalamazoo MI 49007", lat:42.2899, lng:-85.5836, country:"USA", state: "Michigan", depar: "", },
{ name:"GLOBE DESIGN & VISION", addr:"49 East 8th Street, Holland MI 49423", lat:42.7904, lng:-86.1050, country:"USA", state: "Michigan", depar: "", },
{ name:"SHADES OPTICAL", addr:"193 West Maple Road, Birmingham MI 48009", lat:42.5466, lng:-83.2160, country:"USA", state: "Michigan", depar: "", },
{ name:"ART OF OPTIKS EDINA", addr:"4999 France Avenue S., Edina MN 55410", lat:44.9126, lng:-93.3290, country:"USA", state: "Minnesota", depar: "", },
{ name:"ART OF OPTIKS WAYZATA", addr:"747 East Lake Street, Wayzata MN 55391", lat:44.9690, lng:-93.5103, country:"USA", state: "Minnesota", depar: "", },
{ name:"FRAME AND FOCUS OPTICAL", addr:"10914 Elm Street, Omaha NE 68144", lat:41.2328, lng:-96.0821, country:"USA", state: "Nebraska", depar: "", },
{ name:"FREMONT FAMILY VISION", addr:"2480 NE Fremont Street, Portland OR 97212", lat:45.5482, lng:-122.6403, country:"USA", state: "Nebraska", depar: "", },
{ name:"OJO OPTIQUE", addr:"125 Lincoln Avenue, Santa Fe NM 87501", lat:35.6885, lng:-105.9385, country:"USA", state: "New Mexico", depar: "", },
{ name:"EYE DESIGN OF WESTCHESTER", addr:"747 White Plains Road, Scarsdale NY 10583", lat:40.9741, lng:-73.8034, country:"USA", state: "New York", depar: "", },
{ name:"EYE OPENERS", addr:"2929 Monroe Avenue, Rochester NY 14618", lat:43.1107, lng:-77.5474, country:"USA", state: "New York", depar: "", },
{ name:"EYE Q", addr:"1676 East 31st Street, Brooklyn NY 11234", lat:40.6127, lng:-73.9409, country:"USA", state: "New York", depar: "", },
{ name:"FELICE DEE AT SAKS", addr:"7 East 49th Street, New York NY 10022", lat:40.7578, lng:-73.9773, country:"USA", state: "New York", depar: "", },
{ name:"FELICE DEE EYEWEAR", addr:"1305 York Avenue, New York NY 10021", lat:40.7652, lng:-73.9551, country:"USA", state: "New York", depar: "", },
{ name:"L'ATELIER MIRA", addr:"224 Grand Street, Brooklyn NY 11211", lat:40.7138, lng:-73.9596, country:"USA", state: "New York", depar: "", },
{ name:"OPTICAL ARTS NY", addr:"4351 Hylan Boulevard, Staten Island NY 10312", lat:40.5345, lng:-74.1538, country:"USA", state: "New York", depar: "", },
{ name:"SILVER LINING OPTICIANS", addr:"92 Thompson Street, New York NY 10012", lat:40.7252, lng:-74.0023, country:"USA", state: "New York", depar: "", },
{ name:"STUDIO OPTIX", addr:"63 West 49th Street, New York NY 10112", lat:40.7590, lng:-73.9800, country:"USA", state: "New York", depar: "", },
{ name:"SURREAL", addr:"70 Greenwich Avenue, New York NY 10011", lat:40.7364, lng:-74.0009, country:"USA", state: "New York", depar: "", },
{ name:"VISUALEYES Amherst", addr:"3845 Main Street Amherst, NY 14226", lat:42.9625, lng:-78.8061, country:"USA", state: "New York", depar: "", },
{ name:"VISUALEYES CITY Buffalo", addr:"735 Elmwood Ave, Buffalo NY 14222", lat:42.9172, lng:-78.8770, country:"USA", state: "New York", depar: "", },
{ name:"RAINBOW OPTICS", addr:"1740 W 18th Ave, Eugene OR 97402", lat:44.0404, lng:-123.1188, country:"USA", state: "Oregon", depar: "", },
{ name:"BLINK OPTICAL BOUTIQUE", addr:"524 N 19th Street, Allentown PA 18104", lat:40.6029, lng:-75.5001, country:"USA", state: "Pennsylvania", depar: "", },
{ name:"HEIDI OPTICS", addr:"223 Fourth Ave, Pittsburgh PA 15222", lat:40.4399, lng:-80.0025, country:"USA", state: "Pennsylvania", depar: "", },
{ name:"LAPPEN RICHARD OD", addr:"1821 Jefferson St, Greensburg PA 15601", lat:40.2748, lng:-79.5539, country:"USA", state: "Pennsylvania", depar: "", },
{ name:"OPTIQUE STYLE", addr:"222 West Rittenhouse Square, Philadelphia PA 19103", lat:39.9495, lng:-75.1730, country:"USA", state: "Pennsylvania", depar: "", },
{ name:"EYE JOY", addr:"5209 North Lamar Blvd, Austin TX 78751", lat:30.3197, lng:-97.7301, country:"USA", state: "Texas", depar: "", },
{ name:"EYE SOCIETY", addr:"Heights Mercantile - 714 Yale St, Houston TX 77007", lat:29.7837, lng:-95.3988, country:"USA", state: "Texas", depar: "", },
{ name:"SANTA FE OPTICAL", addr:"1601 West 38th Street, Austin TX 78731", lat:30.3087, lng:-97.7499, country:"USA", state: "Texas", depar: "", },
{ name:"THE EYE GALLERY", addr:"1806 Westheimer Road, Houston TX 77098", lat:29.7428, lng:-95.4049, country:"USA", state: "Texas", depar: "", },
{ name:"VIS. OPTICS", addr:"801 South 800 East, Salt Lake City UT 84102", lat:40.7519, lng:-111.8681, country:"USA", state: "Utah", depar: "", },
{ name:"COLAIZZO OPTICIANS", addr:"1623 Queen Anne Ave N, Seattle WA 98109", lat:47.6340, lng:-122.3571, country:"USA", state: "Washington", depar: "", },
{ name:"INSIGHT OPTICIANS", addr:"1240 F St NW Washington, DC 20004", lat:38.8973, lng:-77.0291, country:"USA", state: "Washington, D.C.", depar: "", },
{ name:"BRASS MONOCLE", addr:"806 16th Ave SW, Calgary AB T2R 0S9", lat:51.0382, lng:-114.0798, country:"Canada", state: "Alberta", depar: "", },
{ name:"CHINOOK OPTICAL", addr:"813 49 Ave SW, Calgary AB T2S 1G8", lat:51.0094, lng:-114.0824, country:"Canada", state: "Alberta", depar: "", },
{ name:"LOUIE EYECARE CENTRE", addr:"10634 124 St, NW Edmonton AB T5N 1S3", lat:53.5504, lng:-113.5364, country:"Canada", state: "Alberta", depar: "", },
{ name:"SMITH & WIGHT OPTICIANS", addr:"2731 Hewes Way NW #102, Edmonton AB T6L 6W6", lat:53.4571, lng:-113.4254, country:"Canada", state: "Alberta", depar: "", },
{ name:"THE MONOCLE OPTOMETRY", addr:"140 Bellerose Dr, St. Albert AB T8N 8N8", lat:53.6505, lng:-113.6154, country:"Canada", state: "Alberta", depar: "", },
{ name:"ARTSEE EYEWEAR", addr:"777 Royal Oak Dr, Victoria BC V8X 4V1", lat:48.4975, lng:-123.3822, country:"Canada", state: "British Columbia", depar: "", },
{ name:"BRUCE TOO", addr:"3553 Main St, Vancouver BC V5V 3N4", lat:49.2533, lng:-123.1010, country:"Canada", state: "British Columbia", depar: "", },
{ name:"EYECITY OPTICAL", addr:"4408 Georgia St, Burnaby BC V5C 2V2", lat:49.2781, lng:-123.0055, country:"Canada", state: "British Columbia", depar: "", },
{ name:"JASON MAYCOCK EYECARE", addr:"1318 Blanshard St, Victoria BC V8W 2J1", lat:48.4267, lng:-123.3622, country:"Canada", state: "British Columbia", depar: "", },
{ name:"LYNN VALLEY OPTOMETRY", addr:"1233 Lynn Valley Rd, North Vancouver BC V7J 0A1", lat:49.3359, lng:-123.0389, country:"Canada", state: "British Columbia", depar: "", },
{ name:"MOSH FRAMEMAKERS", addr:"318 Homer St, Vancouver BC V6B 2V2", lat:49.2837, lng:-123.1100, country:"Canada", state: "British Columbia", depar: "", },
{ name:"NICHE EYEWEAR BOUTIQUE", addr:"1965 W 4th Ave, Vancouver BC V6J 1M8", lat:49.2683, lng:-123.1497, country:"Canada", state: "British Columbia", depar: "", },
{ name:"FOR EYES OPTICAL BOUTIQUE", addr:"212 Regent Ave W, Winnipeg MB R2C 1R2", lat:49.8948, lng:-97.0065, country:"Canada", state: "Manitoba", depar: "", },
{ name:"LANG OPTOMETRY & EYEWEAR", addr:"5550 Kaye St, Halifax NS B3K 1Y5", lat:44.6616, lng:-63.5993, country:"Canada", state: "Nova Scotia", depar: "", },
{ name:"BLINK EYEWEAR", addr:"23 St Marie St, Collingwood ON L9Y 3J9", lat:44.5024, lng:-80.2155, country:"Canada", state: "Ontario", depar: "", },
{ name:"COLES & KEYS", addr:"25 York St, Stratford ON N5A 1A1", lat:43.3718, lng:-80.9836, country:"Canada", state: "Ontario", depar: "", },
{ name:"INSIGHT EYE CARE", addr:"49 Albert St Waterloo, ON N2L 3S1", lat:43.4666, lng:-80.5249, country:"Canada", state: "Ontario", depar: "", },
{ name:"JUSTIN BARRY OPTICAL Ltd", addr:"13 King St W, Bowmanville ON L1C 1R2", lat:43.9123, lng:-78.6898, country:"Canada", state: "Ontario", depar: "", },
{ name:"MAC & CO Eyecare", addr:"9025 Torbram Rd, Brampton ON L6S 3L2", lat:43.7356, lng:-79.7067, country:"Canada", state: "Ontario", depar: "", },
{ name:"MIDTOWN EYECARE", addr:"1867 Yonge St, Toronto ON M4S 1Y5", lat:43.6972, lng:-79.3959, country:"Canada", state: "Ontario", depar: "", },
{ name:"OPTIC ZONE", addr:"33 Jarvis St, Toronto ON M5E 1N3", lat:43.6498, lng:-79.3714, country:"Canada", state: "Ontario", depar: "", },
{ name:"OPTICA HERMOSO", addr:"14981 Yonge St, Aurora ON L4G 1M5", lat:43.9931, lng:-79.4656, country:"Canada", state: "Ontario", depar: "", },
{ name:"RAPP OPTICAL", addr:"788 College St, Toronto ON M6G 1C6", lat:43.6549, lng:-79.4211, country:"Canada", state: "Ontario", depar: "", },
{ name:"TOGETHER AGAIN", addr:"182 Woolwich St., Guelph, ON N1H 3V6", lat:43.5480, lng:-80.2530, country:"Canada", state: "Ontario", depar: "", },
{ name:"VIEW EYE CARE", addr:"151 Bloor St W, Toronto ON M5S 1S4", lat:43.6686, lng:-79.3932, country:"Canada", state: "Ontario", depar: "", },
{ name:"GEORGES LAOUN", addr:"4012 Rue Saint Denis, Montreal QC H2W 2M2", lat:45.5205, lng:-73.5758, country:"Canada", state: "Quebec", depar: "", },
{ name:"OPTIBOUTIQ", addr:"1026 Av Cartier, Quebec City QC G1R 2S4", lat:46.8038, lng:-71.2265, country:"Canada", state: "Quebec", depar: "", },
{ name:"PHILEMON MAISON d'OPTIQUE", addr:"35 Allée de Hambourg, Gatineau QC J9J 4J6", lat:45.4340, lng:-75.7986, country:"Canada", state: "Quebec", depar: "", },
{ name:"OPTICAL IMAGE", addr:"95 Central Ave N, Swift Current SK S9H 0K8", lat:50.2834, lng:-107.7996, country:"Canada", state: "Saskatchewan", depar: "", },
{ name:"OPTIKA ECLECTIC EYEWARE", addr:"702 Broadway Ave, Saskatoon SK S7N 1B4", lat:52.1187, lng:-106.6572, country:"Canada", state: "Saskatchewan", depar: "", },
{ name:"SPEX BY RYAN", addr:"2326 Albert St, Regina SK S4P 2V7", lat:50.4419, lng:-104.6186, country:"Canada", state: "Saskatchewan", depar: "", },
{ name:"SPEX by Ryan Saskatoon inc.", addr:"1202 Emerson Ave, Saskatoon SK S7H 2X1", lat:52.1140, lng:-106.6176, country:"Canada", state: "Saskatchewan", depar: "", },
{ name:"GEORGE SKOUFIS OPTOMETRIST", addr:"38A Oxford Street, Paddington (Sydney) 2021", lat:-33.8821, lng:151.2202, country:"Australia", state: "", depar: "", },
{ name:"ONÈJ OPTOMETRIST", addr:"Shop 4 Boggo Road Village, 29 Boggo Rd, Dutton Park (QLD) 4102", lat:-27.4952, lng:153.0291, country:"Australia", state: "", depar: "", },
{ name:"PUYI OPTICAL LIMITED", addr:"Ocean Centre, Harbour City, Tsim Sha Tsui, Hong Kong", lat:22.2953, lng:114.1688, country:"China", state: "", depar: "", },
{ name:"BRYLES OPTIKA", addr:"Pražská tržnice Hala 29A, Prague 7, 170 00", lat:50.0949, lng:14.4502, country:"Czechia", state: "", depar: "", },
{ name:"OPTIKERNE", addr:"Værnedamsvej 12, Copenhagen V 1619", lat:55.6738, lng:12.5500, country:"Denmark", state: "", depar: "", },
{ name:"AUGAPFEL AUGENOPTIK", addr:"Hartstraße 1, Magdeburg 39104", lat:52.1308, lng:11.6390, country:"Germany", state: "", depar: "", },
{ name:"NORDENDBLICK", addr:"Eckenheimer Landstraße 56, Frankfurt am Main 60318", lat:50.1231, lng:8.6865, country:"Germany", state: "", depar: "", },
{ name:"OPTIK REHBEIN", addr:"Lange Straße 39, Delbrück 33129", lat:51.7630, lng:8.5591, country:"Germany", state: "", depar: "", },
{ name:"ENYANEI EINAIM LTD", addr:"141 Ahuza Street, Ra'anana 4337325", lat:32.1808, lng:34.8723, country:"Israel", state: "", depar: "", },
{ name:"HAMASHKIFA", addr:"98 Ussishkin Street, Ramat Hasharon 47204", lat:32.1476, lng:34.8458, country:"Israel", state: "", depar: "", },
{ name:"MATIS", addr:"Piazza San Rocco 10, Vedano Olona (Varese) 21040", lat:45.7769, lng:8.8860, country:"Italy", state: "", depar: "", },
{ name:"INOCO LAB JAPAN", addr:"231-0023 Yokohama (10th fl), Yokohama (Naka) 231-0023", lat:35.4439, lng:139.6527, country:"Japan", state: "", depar: "", },
{ name:"PERIK HOREN & ZIEN", addr:"Willem-Alexanderstraat 2G, Nijverdal 7442 MA", lat:52.3645, lng:6.4621, country:"Netherlands", state: "", depar: "", },
{ name:"BOSSINADE OPTIEK", addr:"Torenstraat 30, Castricum 1901 ED", lat:52.5487, lng:4.6637, country:"Netherlands", state: "", depar: "", },
{ name:"L'ATELIER OPTICA", addr:"C. de Moratín, 18, Centro, 28014 Madrid", lat:40.4124, lng:-3.6967, country:"Spain", state: "", depar: "", },
{ name:"L'ATELIER OPTICA", addr:"Calle de Santiago, 8, Centro, 28013 Madrid", lat:40.4163, lng:-3.7100, country:"Spain", state: "", depar: "", },
{ name:"OPTIK LANGE GMBH", addr:"Bahnhofstrasse 5, Stäfa 8712", lat:47.2402, lng:8.7191, country:"Switzerland", state: "", depar: "", },
{ name:"CREATEUR DE VUE", addr:"Rue de l'Eglise 2, Fully 1926", lat:46.1389, lng:7.1179, country:"Switzerland", state: "", depar: "", },
{ name:"AUERBACH & STEELE", addr:"123 King's Road, London (Chelsea) SW3 4PL", lat:51.4884, lng:-0.1661, country:"UK", state: "", depar: "", },
{ name:"EYE LEVEL ISLINGTON", addr:"37 Upper Street, London (Islington) N1 0PN", lat:51.5348, lng:-0.1052, country:"UK", state: "", depar: "", },
];

/* ---------- Outils ---------- */
function escapeHtml(s){
  return String(s).replace(/[&<>"']/g, c => (
    {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]
  ));
}
function debounce(fn, ms){
  let t;
  return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
}
function dist(a,b){ // km, formule haversine
  const R=6371,dLat=(b.lat-a.lat)*Math.PI/180,dLng=(b.lng-a.lng)*Math.PI/180;
  const x=Math.sin(dLat/2)**2+Math.cos(a.lat*Math.PI/180)*Math.cos(b.lat*Math.PI/180)*Math.sin(dLng/2)**2;
  return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}
/* Vol animé, sauf si l'utilisateur préfère réduire les animations. */
function gotoView(latlng, zoom, duration){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    map.setView(latlng, zoom);            // instantané
  } else {
    map.flyTo(latlng, zoom, { duration });
  }
}
/* Vol en deux temps : léger dézoom sur place, puis vol + zoom vers le magasin. */
let _pendingFly = null;
function flyToStore(latlng, zoom){
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce){ map.setView(latlng, zoom); return; }

  // Annule une éventuelle animation enchaînée d'un clic précédent.
  if(_pendingFly){ map.off('moveend', _pendingFly); _pendingFly = null; }

  const current = map.getZoom();
  const outZoom = Math.max(map.getMinZoom(), Math.min(current, zoom) - 2);

  // Déjà dézoomé : inutile de ressortir, on vole directement.
  if(current <= outZoom + 0.2){
    map.flyTo(latlng, zoom, { duration:1.6 });
    return;
  }

  // Phase 1 : léger dézoom sur place.
  map.flyTo(map.getCenter(), outZoom, { duration:0.55 });
  _pendingFly = () => {
    map.off('moveend', _pendingFly); _pendingFly = null;
    // Phase 2 : vol vers le magasin et zoom.
    map.flyTo(latlng, zoom, { duration:1.6 });
  };
  map.on('moveend', _pendingFly);
}

/* ---------- Carte ---------- */
const map = L.map('map', {
  scrollWheelZoom:true,
  zoomControl:true,
  minZoom:2,
  maxBounds:[[-85, -180], [85, 180]],
  maxBoundsViscosity:1.0,
  worldCopyJump:false
});
// Vue par défaut (monde entier) — filet de sécurité si la liste est vide au chargement.
map.setView([20, 0], 2);

L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
  attribution:'&copy; <a href="https://stadiamaps.com/">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  maxZoom:20
}).addTo(map);

/* Groupe de regroupement (cluster) — indispensable pour une liste mondiale. */
function clusterIcon(cluster){
  const n = cluster.getChildCount();
  const size = n < 10 ? 34 : n < 50 ? 40 : 46;
  const style = [
    'width:'+size+'px','height:'+size+'px','box-sizing:border-box',
    'border-radius:50%','display:flex','align-items:center','justify-content:center',
    'background:#000000','color:#ffffff','border:3px solid #ffffff',
    'box-shadow:0 1px 5px rgba(0,0,0,.3)',
    'font-weight:600','font-size:13px','font-variant-numeric:tabular-nums'
  ].join(';');
  return L.divIcon({
    html:'<div style="'+style+'">'+n+'</div>',
    className:'',
    iconSize:[size,size]
  });
}
const cluster = L.markerClusterGroup({
  showCoverageOnHover:false,
  maxClusterRadius:60,
  chunkedLoading:true,
  iconCreateFunction:clusterIcon
});
map.addLayer(cluster);

const listEl   = document.getElementById('list');
const countEl  = document.getElementById('count');
const searchEl = document.getElementById('search');
const clearEl  = document.getElementById('clear');
const statusEl = document.getElementById('status');

/* Données + marqueurs créés UNE SEULE FOIS (id stable). */
const stores = REVENDEURS.map((r,i) => ({ ...r, id:i }));
const markerById = new Map();

function makeIcon(){
  const style = [
    'width:18px','height:18px','box-sizing:border-box','border-radius:50%',
    'background:#000000','border:3px solid #ffffff',
    'box-shadow:0 1px 4px rgba(0,0,0,.28)','transition:transform .18s'
  ].join(';');
  return L.divIcon({
    className:'',
    html:'<div class="pin" style="'+style+'">'+'</div>',
    iconSize:[18,18], iconAnchor:[9,9]
  });
}
function popupHtml(s){
  // Itinéraire basé sur les COORDONNÉES exactes (plus fiable que le texte d'adresse).
  const g = 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng;
  return '<div class="pop-name">'+escapeHtml(s.name)+'</div>'+
         '<div class="pop-addr">'+escapeHtml(s.addr)+'</div>'+
         '<a class="pop-link" href="'+g+'" target="_blank" rel="noopener">Itinéraire →</a>';
}
stores.forEach(s => {
  const marker = L.marker([s.lat,s.lng], { icon:makeIcon() });
  marker.bindPopup(popupHtml(s));
  marker.on('click', () => focusStore(s.id));
  markerById.set(s.id, marker);
});

/* Repère de localisation (utilisateur ou ville recherchée). */
let refPoint = null;          // { lat, lng, label }
let locationMarker = null;

function setStatus(msg){ statusEl.textContent = msg || ''; }
function updateClear(){ clearEl.hidden = !(searchEl.value || refPoint); }

function placeLocationMarker(point, label, kind){
  if(locationMarker) map.removeLayer(locationMarker);
  locationMarker = L.marker([point.lat,point.lng], {
    icon: L.divIcon({ className:'', html:'<div class="locdot '+kind+'"></div>', iconSize:[16,16], iconAnchor:[8,8] }),
    zIndexOffset: 1000,
    keyboard: false
  }).addTo(map);
  if(label) locationMarker.bindTooltip(label, { direction:'top', offset:[0,-8] });
}

/* ---------- Construction de la liste affichée ---------- */
// Applique le filtre texte + le tri par distance (si un repère est défini).
function currentList(){
  let list = stores;
  const q = searchEl.value.trim().toLowerCase();
  if(q){
    list = list.filter(s => (s.name + ' ' + s.addr).toLowerCase().includes(q));
  }
  if(refPoint){
    list = list.map(s => ({ ...s, _dist:dist(refPoint, s) }))
               .sort((a,b) => a._dist - b._dist);
  } else {
    // Regroupe par pays (ordre = ORDRE_PAYS ; ordre du tableau conservé à l'intérieur).
    list = [...list].sort((a,b) => countryRank(a.country) - countryRank(b.country));
  }
  return list;
}

/* État déplié, un seul ouvert par niveau (accordéon).
   null = tout replié à ce niveau. */
let openCountry = null;
let openRegion  = null;   // état/province pour USA-Canada, région pour la France
let openDept    = null;   // département (France uniquement)

/* Après re-rendu, amène l'en-tête correspondant en haut de la vue. */
function scrollHeadToTop(label){
  requestAnimationFrame(() => {
    const heads = listEl.querySelectorAll('.group-head .group-name');
    for(const el of heads){
      if(el.textContent === label){
        const head = el.closest('.group-head');
        // La liste défile-t-elle en interne (desktop) ou est-ce la page (mobile) ?
        const listScrolls = listEl.scrollHeight > listEl.clientHeight + 1;
        if(listScrolls){
          listEl.scrollTop = head.offsetTop;            // desktop : défile la liste
        } else {
          head.scrollIntoView({ block:'start' });       // mobile : défile la page
        }
        break;
      }
    }
  });
}

function toggleCountry(c){
  const opening = openCountry !== c;
  openCountry = opening ? c : null;
  openRegion = null; openDept = null;
  render(currentList());
  if(opening) scrollHeadToTop(c);
}
function toggleRegion(r){
  const opening = openRegion !== r;
  openRegion = opening ? r : null;
  openDept = null;
  render(currentList());
  if(opening) scrollHeadToTop(r);
}
function toggleDept(d){
  const opening = openDept !== d;
  openDept = opening ? d : null;
  render(currentList());
  if(opening) scrollHeadToTop(d);
}

/* Crée un bouton "magasin" pour la liste. */
function makeItemBtn(s){
  const btn = document.createElement('button');
  btn.className = 'item';
  btn.type = 'button';
  btn.dataset.id = s.id;
  btn.innerHTML =
    '<div class="item-name">'+escapeHtml(s.name)+'</div>'+
    '<div class="item-addr">'+escapeHtml(s.addr)+'</div>'+
    (s._dist != null
      ? '<div class="item-dist">à '+s._dist.toFixed(0)+' km '+(refPoint?.label || '')+'</div>'
      : '');
  btn.addEventListener('click', () => focusStore(s.id));
  return btn;
}

/* Crée un en-tête de groupe cliquable (pays / région / département). */
function makeGroupHead(label, level, isOpen, onClick){
  const head = document.createElement('button');
  head.type = 'button';
  head.className = 'group-head group-head--l'+level + (isOpen ? ' open' : '');
  head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  head.innerHTML =
    '<span class="group-name">'+escapeHtml(label)+'</span>'+
    '<span class="group-meta">'+
      '<svg class="chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"></path></svg>'+
    '</span>';
  head.addEventListener('click', onClick);
  return head;
}

function render(list, { fit = true } = {}){
  cluster.clearLayers();
  listEl.innerHTML = '';
  // Réinitialise l'état actif des marqueurs persistants.
  markerById.forEach(m => {
    const el = m.getElement()?.querySelector('.pin');
    if(el){
      el.style.background = '#000000';
      el.style.transform  = 'scale(1)';
      el.style.boxShadow  = '0 1px 4px rgba(0,0,0,.28)';
    }
  });

  countEl.textContent = list.length;
  updateClear();

  if(!list.length){
    listEl.innerHTML = '<p class="item-empty">Aucun revendeur ne correspond à votre recherche. Essayez une ville, ou réinitialisez la recherche.</p>';
    return; // On conserve la vue carte actuelle.
  }

  const layers = [];
  const searchActive = !!searchEl.value.trim();
  const grouped = !refPoint;            // pas d'en-têtes en tri par distance

  if(grouped){
    // Regroupe par pays en conservant l'ordre déjà trié.
    const countries = new Map();
    list.forEach(s => {
      const c = s.country || '—';
      if(!countries.has(c)) countries.set(c, []);
      countries.get(c).push(s);
    });

    const searchActive = !!searchEl.value.trim();

    // Construit un panneau repliable contenant des enfants.
    function panel(open, buildChildren){
      const p = document.createElement('div');
      p.className = 'group-panel' + (open ? ' open' : '');
      const inner = document.createElement('div');
      inner.className = 'group-panel-inner';
      if(open) buildChildren(inner);
      p.appendChild(inner);
      return p;
    }

    countries.forEach((cItems, country) => {
      const cOpen = searchActive || openCountry === country;
      listEl.appendChild(
        makeGroupHead(country, 1, cOpen, () => toggleCountry(country))
      );

      listEl.appendChild(panel(cOpen, cInner => {
        const hasDept = country === 'France';   // 3 niveaux pour la France
        const hasRegion = country === 'France' || country === 'USA' || country === 'Canada';

        if(!hasRegion){
          // Pays sans sous-niveau : magasins directement sous le pays.
          cItems.forEach(s => {
            cInner.appendChild(makeItemBtn(s));
            layers.push(markerById.get(s.id));
          });
          return;   // on saute le regroupement par région
        }

        // Regroupe ce pays par "state" (= région FR / état US-CA).
        const regions = new Map();
        cItems.forEach(s => {
          const r = s.state || '—';
          if(!regions.has(r)) regions.set(r, []);
          regions.get(r).push(s);
        });

        regions.forEach((rItems, region) => {
          const rOpen = searchActive || (cOpen && openRegion === region);
          cInner.appendChild(
            makeGroupHead(region, 2, rOpen, () => toggleRegion(region))
          );

          cInner.appendChild(panel(rOpen, rInner => {
            if(hasDept){
              // Niveau département (France).
              const depts = new Map();
              rItems.forEach(s => {
                const d = s.depar || '—';
                if(!depts.has(d)) depts.set(d, []);
                depts.get(d).push(s);
              });
              depts.forEach((dItems, dept) => {
                const dOpen = searchActive || (rOpen && openDept === dept);
                rInner.appendChild(
                  makeGroupHead(dept, 3, dOpen, () => toggleDept(dept))
                );
                rInner.appendChild(panel(dOpen, dInner => {
                  dItems.forEach(s => {
                    dInner.appendChild(makeItemBtn(s));
                    layers.push(markerById.get(s.id));
                  });
                }));
              });
            } else {
              // USA / Canada : les magasins directement sous l'état.
              rItems.forEach(s => {
                rInner.appendChild(makeItemBtn(s));
                layers.push(markerById.get(s.id));
              });
            }
          }));
        });
      }));
    });
    
  } else {
    // Mode distance : liste à plat, sans en-têtes.
    list.forEach(s => {
      listEl.appendChild(makeItemBtn(s));
      layers.push(markerById.get(s.id));
    });
  }

  const showMarkers = searchActive || !!refPoint;
  if(showMarkers){
    cluster.addLayers(layers);
    if(fit) fitAll(list);
  }
}

function focusStore(id){
  // État actif dans la liste.
  listEl.querySelectorAll('.item').forEach(b =>
    b.classList.toggle('active', b.dataset.id === String(id))
  );
  // État actif des marqueurs (styles en ligne, robustes au thème).
  markerById.forEach((m, mid) => {
    const el = m.getElement()?.querySelector('.pin');
    if(!el) return;
    const active = mid === id;
    el.style.background = active ? '#000000' : '#000000';
    el.style.transform  = active ? 'scale(1.45)' : 'scale(1)';
    el.style.boxShadow  = active
      ? '0 0 0 5px rgba(188,138,61,.22),0 1px 5px rgba(0,0,0,.3)'
      : '0 1px 4px rgba(0,0,0,.28)';
  });

  const marker = markerById.get(id);
  if(!marker) return;
  const searching = !!searchEl.value.trim() || !!refPoint;
  if(!searching){
    cluster.clearLayers();      // carte vide : on n'affiche que le point choisi
    cluster.addLayer(marker);
  } else if(!cluster.hasLayer(marker)){
    cluster.addLayer(marker);
  }
  // Vol direct vers le magasin — plus de double zoom.
  flyToStore(marker.getLatLng(), 13);
  marker.openPopup();
  const el = marker.getElement()?.querySelector('.pin');
  if(el){
    el.style.background = '#000000';
    el.style.transform  = 'scale(1.45)';
    el.style.boxShadow  = '0 0 0 5px rgba(188,138,61,.22),0 1px 5px rgba(0,0,0,.3)';
  }

  const btn = listEl.querySelector('.item[data-id="'+id+'"]');

  // Mobile : la carte est au-dessus de la liste → on y remonte pour voir le résultat.
  const mapScrolls = listEl.scrollHeight <= listEl.clientHeight + 1; // vrai = page défile (mobile)
  if(mapScrolls){
    document.getElementById('map').scrollIntoView({ block:'start', behavior:'smooth' });
  } else {
    btn?.scrollIntoView({ block:'nearest', behavior:'smooth' });
  }
}

function fitAll(list){
  if(list.length === 1){ map.setView([list[0].lat, list[0].lng], 11); return; }
  const b = L.latLngBounds(list.map(r => [r.lat, r.lng]));
  map.fitBounds(b, { padding:[50,50] });
}

/* ---------- Recherche texte (filtre en direct, anti-rebond) ---------- */
searchEl.addEventListener('input', debounce(() => {
  render(currentList());
}, 200));

/* Entrée = traiter le texte comme une VILLE et y voler (géocodage Nominatim). */
searchEl.addEventListener('keydown', e => {
  if(e.key === 'Enter'){ e.preventDefault(); geocodeJump(searchEl.value.trim()); }
});

/* Géocodage de ville via Nominatim (OpenStreetMap).
   NB : usage gratuit limité à ~1 req/s ; appelé uniquement sur "Entrée".
   Pour un fort trafic, préférez un géocodeur dédié (MapTiler, etc.). */
async function geocodeJump(q){
  if(!q) return;
  setStatus('Recherche de « ' + q +' »…');
  try{
    const url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(q);
    const res = await fetch(url, { headers:{ 'Accept':'application/json' } });
    const data = await res.json();
    if(!data.length){ setStatus('Lieu introuvable. Précisez votre recherche.'); return; }

    const place = data[0];
    const shortName = (place.display_name || q).split(',')[0].trim();
    refPoint = { lat:+place.lat, lng:+place.lon, label:'de ' + shortName };
    placeLocationMarker(refPoint, shortName, 'place');

    searchEl.value = '';                 // on retire le filtre texte

    const sorted = currentList();                       // déjà trié par distance
    const within = sorted.filter(s => s._dist <= 30);   // rayon de 30 km
    const fallback = within.length === 0;
    const list = fallback ? sorted.slice(0, 5) : within;

    render(list, { fit:false });
    if(list[0]){
      setStatus(fallback
        ? 'Aucun point de vente à moins de 30 km de ' + shortName + '. Voici les 5 plus proches.'
        : 'Points de vente dans un rayon de 30 km de ' + shortName + '.');
      focusStore(list[0].id);
    } else {
      gotoView([refPoint.lat, refPoint.lng], 11, .8);
      setStatus('Aucun point de vente trouvé.');
    }
  }catch(err){
    setStatus('Recherche indisponible pour le moment.');
  }
}

/* ---------- Autour de moi ---------- */
document.getElementById('near').addEventListener('click', () => {
  if(!navigator.geolocation){ setStatus("La géolocalisation n'est pas disponible sur votre navigateur."); return; }
  setStatus('Localisation en cours…');
  navigator.geolocation.getCurrentPosition(pos => {
    refPoint = { lat:pos.coords.latitude, lng:pos.coords.longitude, label:'de vous' };
    placeLocationMarker(refPoint, 'Vous êtes ici', 'me');
    searchEl.value = '';
    const sorted = currentList();                       // déjà trié par distance
    const within = sorted.filter(s => s._dist <= 30);   // rayon de 30 km
    const fallback = within.length === 0;               // rien dans le rayon ?
    const list = fallback ? sorted.slice(0, 5) : within;
    render(list, { fit:false });
    if(list[0]){
      setStatus(fallback
        ? 'Aucun point de vente à moins de 30 km. Voici les 5 plus proches.'
        : 'Points de vente dans un rayon de 30 km.');
      focusStore(list[0].id);
    } else {
      setStatus('Aucun point de vente trouvé.');
    }
  }, () => {
    setStatus("Localisation refusée. Activez-la pour trouver le revendeur le plus proche.");
  });
});

/* ---------- Réinitialiser ---------- */
clearEl.addEventListener('click', () => {
  searchEl.value = '';
  refPoint = null;
  if(locationMarker){ map.removeLayer(locationMarker); locationMarker = null; }
  setStatus('');
  render(currentList());
  searchEl.focus();
});

/* ---------- Init ---------- */
render(currentList());